import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '@/hooks/useRouter';
import User from '@/pages/_common_user/ManageUser';
import useQuery from './useQuery';
import DateJoined from '@/pages/_common_user/User/DateJoined';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';

export default function Layout() {
  const { location } = useRouter();
  const launch = useDialogLauncher();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  const csvQuery = useQuery({
    returnCsvQuery: true
  });

  function onDownload(query) {
    launch(DialogManager.CSVDownload.Config(query));
  }

  // todo: csv download needs to be reworked for these special queries
  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Educators']}
      title="Creating at your sites"
      description={(
        <span>
          Any educator at one of your sites who has created at least one project or event.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      csvQuery={function () {
        onDownload(csvQuery);
      }}
      row={function(user) {
        return (
          <User key={user.id} user={user}>
            <div className="bg-cs-gray-50 p-4 border-t border-cs-gray-100">
              <DateJoined user={user} />
            </div>
          </User>
        );
      }}
    />
  );
}
